import { type } from 'arktype'

export const rcphProducts = ['TECH', 'MAC', 'MAN', 'MEDIA', 'MISC', 'MISCBIE', 'SECU', 'TAG', 'ECOM'] as const

export const RcphProductSchema = type('===', ...rcphProducts)
/**
 * Enumerated the "Products" according to Hiscox RC Pro
 */
export type RcphProduct = typeof RcphProductSchema.infer
